import View from './View';

export { default as View, getTechnicalInfoScreenStyles } from './View';

export default View;
